/**
 * Created by wangjun on 2019/6/16.
 */
import React, { Component } from 'react';
import './right-selectors.scss';
import Selector from './selector/selector';
import SelectorTitle from './selector-title/selector-title';
import EmptySelector from './empty-selector/empty-selector';
import { API } from "../common/config";
import { Event } from "../common/event";

import { FBXLoader } from '../common/es6-class';
import { checkStatus, parseJSON } from "../common/http";

export default class RightSelectors extends Component {
  constructor(props) {
    super(props);
    //todo modelId
    this.colors = [];
    this.types = [];
    this.parts = [];
    this.state = {
      parts: null,
      product: null,
      selectedMainColor: null,
      selectedHandle: null,
      selectedWindow: null,
      selectedGauze: null
    };
  }


  getModel() {
    let promise = [];
    promise[0] = fetch(API.getColor).then(res=>res.json());
    promise[1] = fetch(API.getTypes).then(res=>res.json());
    promise[2] = fetch(API.getParts).then(res=>res.json());

    Promise.all(promise).then(
        (result)=>{
          this.colors = result[0];
          this.types = result[1];
          this.parts = result[2];
        }
    );
  }

  transform() {
    Event.on('ProductChange',async (value)=>{
      this.setState({product: value,parts: null});
      if(value && (value.id == 31 || value.categoryId !== 6) ) {
      let id = value.id;
      fetch(API.getPartsByPId)
            .then(checkStatus)
            .then(parseJSON)
            .then(
                (parts)=>{
                  this.updateData(parts,id);
                },
                (error)=>{
                  this.setState({parts: null});
                }
            )

      }
    });
  }

  updateData(parts,id) {
    let ps = [];
    parts.forEach((p)=>{
      if(p.productid == id) {
        ps.push(p);
      }
    });
    let data = this.formatParts(ps);
    data.forEach(v=>{
      if(v.id == 2) {
        v.children.forEach(v=>{
          if(v.fbxPath) {
            let fbxPath = v.fbxPath.replace("{id}",id);
            v.fbx = this.loaderMaterials(fbxPath);
          }
        });
      }
    })
    this.setState({parts: data});
  }

  async loaderMaterials(path) {
    let loader = new FBXLoader();
    let mesh = await new Promise((resolve)=>{
        loader.load(path,(g)=>resolve(g));
    });
    return mesh;
  }

  formatParts(parts) {
    let threeNode = {};
    for(let l of parts) {
      if(threeNode[l.typeid]) {
        if(threeNode[l.typeid][l.partid]) {
          threeNode[l.typeid][l.partid].push(l.colorid);
        }else{
          threeNode[l.typeid][l.partid] = [l.colorid];
        }
      }else{
        threeNode[l.typeid] = {};
        threeNode[l.typeid][l.partid] = [l.colorid];
      }
    }
    let result = [];
    for(let index in threeNode) {
      let node = this.types.find(j=>(j.id == index));
      node = node ? {...node} : {};
      node.children = [];
      for(let index1 in threeNode[index]) {
        let node1 = this.parts.find(j=>(j.id == index1));
        node1 = node1 ? {...node1} : null;
        let children = [];
        for(let index2 in threeNode[index][index1]) {
          let node2 = this.colors.find(j=>(j.id == threeNode[index][index1][index2]));
          if(node2) {
            node2 = {...node2};
            node2.type = parseInt(index);
            node2.productId = this.state.product.id;
            children.push(node2);
          }
        }
        if(node1){
          node1.type = parseInt(index);
          node1.productId = this.state.product.id;
          node1.children = children;
          node.children.push(node1);
        }else{
          node.children = children;
        }
      }
      result.push(node);
    }
    return result;
  }

  componentDidMount() {
    this.getModel();
    this.transform();

  }

  setStates(typeid,value) {
    switch(typeid) {
      case 1:
        this.setState({selectedMainColor: value});
        break;
      case 2:
        this.setState({selectedHandle: value});
        break;
      case 3:
        this.setState({selectedWindow: value});
        break;
      case 4:
        this.setState({selectedGauze: value});
        break;  
    }
  }

  renderChildParts(type) {
      if(type === 2 && this.state.selectedHandle && this.state.selectedHandle.children) {
         let lists = this.sortByOrder(this.state.selectedHandle.children);
         return (
          <Selector lists={lists} type={-1} defaultSelected={this.state.selectedMainColor} callback={this.activeChange.bind(this)}></Selector>
        )
      }else if(type === 4 && this.state.selectedGauze && this.state.selectedGauze.children){
        let lists = this.sortByOrder(this.state.selectedGauze.children);
        return (
          <Selector lists={lists} type={-1} callback={this.activeChange.bind(this)}></Selector>
        )
      }
  }

  sortByOrder(arr) {
    if(arr[0] && arr[0].order) {
      let arr2 = arr.sort((a,b)=>(a.order - b.order));
      return arr2;
    }
    return arr;
  }
  activeChange(e) {
    this.setStates(e.type,e);
  }

  render() {
    if(this.state.product && (this.state.product.categoryId ===6 && this.state.product.id != 31)) {
      return (
        <div className="right-selectors">
          <div className="child">

             <div className="description">
               {this.state.product.description}
             </div>
          </div>
        </div>
      )
    }else if(this.state.parts) {
      return (
        <div className="right-selectors">
          <div className="child">
            {
              this.state.parts.map(v=>{
                  let lists = this.sortByOrder(v.children);
                  return (
                    <div key={v.id}>
                      {
                        v.type != 3 ? <SelectorTitle title={v.name}></SelectorTitle>: null
                      }
                      <Selector lists={lists} type={v.id} callback={this.activeChange.bind(this)}></Selector>
                      {this.renderChildParts(v.id)}
                    </div>
                    )
              })
            }
          </div>
        </div>
      )
    }else{
      return (
        <div className="right-selectors">
          <div className="child">
            <EmptySelector type="1"></EmptySelector>
            <EmptySelector type="2"></EmptySelector>
            <EmptySelector type="2"></EmptySelector>
          </div>
        </div>
      )
    }
  }

  renderDescription() {
    if(this.state.product && this.state.product.description) {
      return (
          <div className="description">
            {this.state.product.description}
          </div>
      );
    }
  }

  

  
}